'use strict';

var base = require('lyonscg/components/carousels');
var slickConfigs = require('../config/slickConfigs');

/* Initialize Circle Nav Swipers */
var circleNavSwiper = function () {
    $(document).ready(function () {
        var $swipers = $('.circle-nav-swiper');

        $swipers.each(function (index) {
            var $this = $(this);
            $this.addClass('circle-nav-swiper-' + index);

            // eslint-disable-next-line no-new, no-unused-vars, no-undef
            new Swiper('.circle-nav-swiper-' + index, {
                // Optional parameters
                direction: 'horizontal',
                slidesPerView: 5.5,
                freeMode: true,
                simulateTouch: true,
                slidesOffsetBefore: 5
            });
        });
    });
};

/* Initialize Loyalty VOucher Swiper */
var voucherSwiper = function () {
    $(document).ready(function () {
        new Swiper(".vouchers-carousel", {
            slidesPerView: "auto",
            spaceBetween: 10,
        });
    });
};

/* Initialized Banner Swipers */
const buildPromoSwiper = sliderElm => {
    const sliderID = '#' + sliderElm.id + ' .swiper-track';
    // const progressBar = document.querySelector(sliderID + ' .autoplay-progress-bar .progress-fill');
    const progressCircle = document.querySelector(sliderID + ' .autoplay-progress .svg-timer');
    // eslint-disable-next-line no-new, no-unused-vars, no-undef
    return new Swiper(sliderID, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        a11y: {
            scrollOnFocus: true
        },
        autoplay: {
            delay: 6000,
            pauseOnMouseEnter: false
        },
        pagination: {
            el: '.swiper-count span',
            type: 'custom',
            clickable: true,
            renderCustom: function (swiper, current, total) {
                return current + ' / ' + total;
            }
        },
        navigation: {
            nextEl: '.swiper-left-right .swiper-btn-next',
            prevEl: '.swiper-left-right .swiper-btn-prev'
        },
        on: {
            afterInit: function (thisSwiper) {
                if (thisSwiper.slides.length === 0) {
                    document.getElementById(sliderElm.id).style.display = 'none';
                }
                // Play/Pause control button
                const controlBtn = document.querySelector(sliderID + ' .swiper-play-pause .swiper-btn-control');
                controlBtn.addEventListener('click', function () {
                    if (this.getAttribute('aria-pressed') === 'false') {
                        thisSwiper.autoplay.pause();
                        this.setAttribute('aria-label', 'Play');
                        this.querySelector('.fa').classList.remove('fa-pause');
                        this.querySelector('.fa').classList.add('fa-play');
                        this.setAttribute('aria-pressed', 'true');
                    } else {
                        thisSwiper.autoplay.resume();
                        this.setAttribute('aria-label', 'Pause');
                        this.querySelector('.fa').classList.remove('fa-play');
                        this.querySelector('.fa').classList.add('fa-pause');
                        this.setAttribute('aria-pressed', 'false');
                    }
                });
            },
            autoplayTimeLeft(s, time, progress) {
                progressCircle.style.setProperty('--progress', 1 - progress);
            }
        }
    });
};

const buildFourTileSwiper = sliderElm => {
    const sliderID = '#' + sliderElm.id + ' .swiper-track';
    // eslint-disable-next-line no-new, no-unused-vars, no-undef
    return new Swiper(sliderID, {
        slidesPerView: 1,
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        a11y: {
            scrollOnFocus: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 24
            },
            991: {
                slidesPerView: 4,
                spaceBetween: 24
            }
        },
        on: {
            afterInit: function (theSwiper) {
                if (theSwiper.slides.length === 0) {
                    document.getElementById(sliderElm.id).style.display = 'none';
                }
            }
        }
    });
};

$(document).ready(function () {
    const heroSliders = document.querySelectorAll('.banner-swiper');
    const fourTileSliders = document.querySelectorAll('.fourTile-swiper');

    if (heroSliders) {
        heroSliders.forEach(slider => buildPromoSwiper(slider));
    }

    if (fourTileSliders) {
        fourTileSliders.forEach(slider => buildFourTileSwiper(slider));
    }
});


base.addedToCartRecommendations = function () {
    $('#addToCartModal .product-tile-caro').slick(slickConfigs.addedToCartRecommendations);
};

base.productTileCarousels = function () {
    $('.product-tile-caro').each(function () {
        var $this = $(this);
        if ($this.children('.slider-item').length < 2) {
            $this.next('.slider-controls').remove();
        }

        $($this).slick({
            speed: 300,
            dots: true,
            appendDots: $($this).parent('.product-tile-caro-wrap').find('.slick-nav'),
            prevArrow: $($this).parent('.product-tile-caro-wrap').find('.prevArrow'),
            nextArrow: $($this).parent('.product-tile-caro-wrap').find('.nextArrow'),
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [{
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
            ]
        });
    });
};

/**
 * Setup Mutation Observers for Recommendations Slots
 * When recommendations markup is loaded, fire off Mutation Observer callback
 * - Init Product Tile Carousel on Recommendation Product Tiles
 */
var initRecommendations = function () {
    var observer = new MutationObserver(function (mutations) {
        var $this = $(mutations[0].target);

        // This is the logic to ensure that initProductTileCarousel()
        // is only fired once. You could also use a Singleton pattern
        var $carousel = $this.find('.product-tile-caro');
        if ($carousel.length && !$carousel.hasClass('slick-initialized')) {
            base.productTileCarousels();
        }
    });

    // Create an observer for CQ Recommendations being injected into
    // slot containers with id starting with cq_recomm_slot
    $('[id^=cq_recomm_slot]').each(function (i, slot) {
        observer.observe(slot, {
            subtree: true,
            childList: true
        });
    });
};


module.exports = {
    base,
    initRecommendations,
    circleNavSwiper,
    voucherSwiper
};
